//
//  navigation.ts
//  moods-film-ui-master
//
//  Created by romainharvier@gmail.com on 10/08/2019.
//  Copyright © 2019 Moods. All rights reserved.
//

import { Vue } from 'vue-property-decorator';

export default class Navigation {

    public readonly name: string;
    public readonly id: string;
    public readonly target: number;
    public readonly content: string;

    constructor(context: Vue, name: string, from: string, index: number) {

        this.name = name;
        this.id = `nav-${index}`;
        this.target = index + 1;
        this.content = context.$i18n.t(`strings.${from}.nav.nav_${name}`).toString();

    }

}
